<template>
    <v-container>
        <div class="text-center my-5">
            <h3>{{$t('Notificaciones/anuncios')}}</h3>
            <span>({{$t('Este anuncio se mostrará al inicio de la tienda')}})</span>
        </div>
        
        <v-row>
            <v-col cols="12" sm="8" offset-sm="2">
                <v-form @submit.prevent="createEditAd" ref="refAds" lazy-validation>
                    <v-card>
                        <v-card-text>
                            <v-select
                                :items="itemsSizes"
                                item-text="label"
                                item-value="val"
                                :label="$t('Tamaño de la imagen')"
                                outlined
                                dense
                                :rules="[rules.required]"
                                v-model="sizeBanner"
                            ></v-select>

                            <div class="text-center">
                                {{$t('Imagen del anuncio')}} *
                            </div>
                            <div style="position: relative; width:250px" class="mb-6 mx-auto">
                                <v-img
                                    :src="previewImg"
                                    :aspect-ratio="sizeBanner"
                                    style="background-color: grey"
                                ></v-img>
                                <v-btn
                                    absolute
                                    dark
                                    fab
                                    bottom
                                    right
                                    @click="openInputFile"
                                >
                                    <v-icon>mdi-image</v-icon>
                                </v-btn>
                                <input type="file" @change="upBanner" class="d-none" ref="fileInput" accept="image/png, image/jpeg">
                            </div>
                            <span class="red--text" v-if="errors['banner']">{{ (errors['banner']) ? errors['banner'][0] : '' }}</span>

                            <!-- status -->
                            <v-switch
                                v-model="state"
                                inset
                                :label="`${$t('Estado')}: ${(state)?$t('activo'):$t('inactivo')}`"
                            ></v-switch>
                            <!-- end status -->
                        </v-card-text>
                        <v-card-actions>
                            <v-btn
                                color="primary"
                                :loading="loading"
                                type="submit"
                            >{{$t('Guardar')}}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
export default {
    data () {
        return {
            loading: false,
            previewImg: '',
            itemsSizes: [
                {val: 1/1, label: '1:1'},
                {val: 2/3, label: '2:3'},
                {val: 3/2, label: '3:2'}
            ],
            banner: null,
            sizeBanner: '',
            state: true,
            // validation
            rules: {
                required: v => !!v || 'El campo es requerido',
                min: v => v.length >= 8 || 'Mínimo 8 caracteres',
                phone: v => (v.length >= 8 && v.length <= 8) || 'Debe contener 8 dígitos',
                email: v => /.+@.+\..+/.test(v) || 'Correo electrónico inválido'
            },
            errors: {}
        }
    },
    props: ['slug'],
    created() {
        this.showAds();
    },
    methods: {
        openInputFile() {
            this.$refs.fileInput.click();
        },
        upBanner(event) {
            const file = event.target.files[0];
            this.previewImg = URL.createObjectURL(file);
            this.banner = file;
        },
        async showAds() {
            await axios.post(`/alerts/${this.slug}`, {})
            .then((response) => {
                if (JSON.stringify(response.data) != '{}') {
                    const tempData = JSON.parse(response.data.content)
                    this.sizeBanner = tempData.size
                    this.previewImg = tempData.banner
                    this.state = (tempData.state)?true:false
                }
            })
            .catch((error) => {
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                }
            })
        },
        /**
         * create or edit
         */
        async createEditAd() {
            if (this.$refs.refAds.validate()) {
                this.loading = true
                const formData = new FormData()
                formData.append('banner', this.banner)
                formData.append('size', this.sizeBanner)
                formData.append('state', this.state?1:0)
                await axios.post('/admin/alerts', formData)
                .then((response) => {
                    // console.log(response)
                    if (response.data === 'ok') {
                        this.$alert('', this.$t('Anuncio actualizado con éxito.'), 'success', {confirmButtonText: this.$t('Continuar')})
                        this.previewImg = ''
                        this.$refs.refAds.resetValidation()
                        this.showAds();
                    }
                    this.loading = false
                })
                .catch((error) => {
                    if (error.response.data.errors) {
                        this.errors = error.response.data.errors
                    }
                    if (error.response.status == 404 || error.response.status == 500) {
                        this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                    }
                    this.loading = false
                })
            }
        }
    },
}
</script>